import { Wordmark } from '../components';

/**
 * Replaces every occurrence of the literal string "MeInvent" inside a
 * plain-text source (FAQ answers, survey question labels, banner copy)
 * with the inline `<Wordmark size="inherit" />` component so the brand
 * mark renders properly in any context.
 *
 * Returns a flat React fragment array suitable for inlining inside a
 * `<p>`, `<div>`, etc. Possessives and trailing punctuation stay
 * intact: "MeInvent's coach" → Wordmark + "'s coach".
 *
 * Used wherever rendered copy comes from a non-React source (the survey
 * schema's string labels, admin-edited template JSON, FAQ entries).
 */
export function renderWithBrand(text: string) {
  // Matches the current brand name and any retired forms still lingering in
  // stored copy (admin-edited templates, older survey JSON): "EntreDash",
  // "MeInvent", and "Me'Invent" (straight or curly apostrophe). All render as
  // the EntreDash wordmark. Split directly (no stateful .test()) to dodge the
  // global-regex lastIndex gotcha.
  if (typeof text !== 'string') return text;
  const parts = text.split(/EntreDash|MeInvent|Me['’]Invent/g);
  if (parts.length === 1) return text;
  return parts.flatMap((part, i) =>
    i === 0 ? [part] : [<Wordmark key={`mark-${i}`} size="inherit" />, part],
  );
}
